import React from 'react';
import { AttractionsSection } from './sections/AttractionsSection';
import { FaqSection } from './sections/FaqSection';
import { PushNotificationsSection } from './sections/PushNotificationsSection';
import { ServicesSection } from './sections/ServicesSection';
import { SponsorsSection } from './sections/SponsorsSection';
import { StagesSection } from './sections/StagesSection';
import { VendorsSection } from './sections/VendorsSection';

export function FestivalRelatedContent({ festivalId }) {
  if (!festivalId) {
    return null;
  }

  return (
    <>
      <StagesSection festivalId={festivalId} />
      <AttractionsSection festivalId={festivalId} />
      <VendorsSection festivalId={festivalId} />
      <SponsorsSection festivalId={festivalId} />
      <ServicesSection festivalId={festivalId} />
      <FaqSection festivalId={festivalId} />
      <PushNotificationsSection festivalId={festivalId} />
    </>
  );
}
